<template>
  <div>
    <div class="primary--text font-weight-bold ml-2">{{ title }}</div>
    <v-menu
      ref="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <div>
          <v-row dense no-gutters>
            <v-col cols="8">
              <v-text-field
                class="rounded-lg"
                dense
                outlined
                readonly
                :background-color="value"
                v-bind="attrs"
                v-on="on"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                class="rounded-lg ml-2"
                ref="input"
                dense
                outlined
                :rules="rules"
                :readonly="disabled"
                :value="value"
                @focus="$emit('focus')"
                @input="$emit('input', $event)"
                v-bind="attrs"
                v-on="on"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </div>
      </template>
      <v-color-picker
        hide-mode-switch
        v-model="model"
        mode="hexa"
      ></v-color-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    title: String,
    disabled: Boolean,
    rules: {
      type: Array,
      default: function () {
        return [(v) => !!v || this.$t("sc.required")];
      },
    },
  },
  computed: {
    model: {
      get: (vm) => {
        let value = vm.value?.hex || vm.value;
        //Si es un HEX de 9 digitos se elimina los 2 ultimos digitos (son para nivel de transparencia)
        if (value?.length === 9) {
          value = value.slice(0, -2);
        }
        return value;
      },
      set(v) {
        let value = v.hex || v;
        //Si es un HEX de 9 digitos se elimina los 2 ultimos digitos (son para nivel de transparencia)
        if (value?.length === 9) {
          value = value.slice(0, -2);
        }
        this.$emit("input", value);
      },
    },
  },
};
</script>
